export class MultiAction {
  constructor(public id: number | null, public name: string) {}
  public static get EMPTY(): MultiAction {
    return new MultiAction(null, "");
  }
}
